<div class="vector-map__infowindow-addresses">
    <h5 class="text--level5 margin-top-half">Choisir une adresse</h5>
    <ul class="list-link no-margin">
        <% for (var i = 0; i < addressList.length; i ++) { %>
            <li>
                <a href="<%= addressList[i].url %>"
                   class="text--level5"
                   data-ua-hit-type="event" data-ua-event-category="Page prix" data-ua-event-action="go:prices:address" data-ua-event-label="prices:map:iw_addresses:address_link"
                   data-linked-place=""
                   data-linked-address=""
                   data-url="<%= addressList[i].url %>"><%= addressList[i].name %></a>
            </li>
        <% } %>
    </ul>
</div>
